import styled from 'styled-components'

export const TooltipButtonWrapper = styled.div``

export const TooltipButtonInner = styled.button`
  display: inline-block;
  cursor: pointer;
  z-index: 20;
  background: transparent;
  border: none;
  padding: 0;
  outline: none !important;
  &:focus,
  &.active {
    outline: 0 !important;
  }
`
